import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Button, Form, Table, Loader, Dimmer, Label} from 'semantic-ui-react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {paths} from '../../../common/dictionaries/urls';
import {buildParameters, addSelectedTasks} from '../../utils';
import {downloadFile} from '../../../common/util/file';
import {Actions} from '../../../common/actions';
import SearchFormMany from './FormReport';
import ReportTable from './ReportTable';
import GenerateFileModal from './modals/GenerateFileModal';
import './styles.scss';

const INITIAL_STATE = {
  'dealer': [],
  'initDate': null,
  'endDate': null,
  'typeTwc': 'TODOS',
  'status': 'TODOS',
  'katashiki': '',
  'invoice': '',
  'account': '',
  'campaignNo': 'TODOS',
  'tasks': [],
  'OFP': '',
  'reportType': null,
  'countRows': 0,
};

class WarrantyReport extends Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentDidMount() {
    if (
      !hasAccessPermission(
        this.props.permissions,
        resources.WarrantyReport,
        scopes.See
      )
    ) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.fetchCampaignList({'status': 'A'});
    this.props.fetchDealers('importers');
    this.props.fetchWarrantyStatus();
  }

  componentDidUpdate() {
    const {fileURL} = this.props;

    if (fileURL) {
      downloadFile(fileURL);
      this.props.clearWarrantyReportURLFile();
    }
  }

  componentWillUnmount() {
    this.props.clearSearchPartWarranty();
    this.props.clearWarrantyReportList();
    this.props.clearReplacementSectionPartQuotes();
  }

  handleSearch = () => {
    const params = buildParameters(this.state);
    this.props.fetchWarrantyReportList(params);
  };

  handleChange = (e, {name, value}) => {
    if (name !== 'tasks') {
      this.setState({[name]: value});
    } else {
      const {tasks} = this.state;
      const tasksValue = addSelectedTasks(tasks, value);
      this.setState({[name]: tasksValue});
    }
  };

  handleChangeDate = (field, date) => {
    this.setState({[field]: date});
  }

  handleClear = () => {
    this.setState(INITIAL_STATE);
  }

  renderContent(validateForm) {
    const {reportType, countRows} = this.state;
    const {loading, reportList} = this.props;

    if (loading) {
      return (
        <Table striped className="toyota-grid">
          <Table.Body>
            <Table.Row>
              <Table.Cell colSpan="100%">
                <Loader active inline="centered" content="Ejecutando" />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    if (!loading && validateForm) {
      return (
        <Table className="toyota-grid">
          <Table.Body>
            <Table.Row textAlign='center'>
              <Table.Cell colSpan="100%">
                <h3>Diligenciar formulario de parametros</h3>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      );
    }

    return (
      <ReportTable
        dataTable={reportList}
        reportType={reportType}
        countRows={countRows}
        handleChange={this.handleChange}
      />
    );
  }

  render() {
    const {initDate, endDate, reportType, countRows, invoice} = this.state;
    const {warrantyStatus, loading, dealers, campaignList, reportList, loadingFile} = this.props;
    const validateForm = !invoice ?
      (!initDate || !endDate || !reportType) :
      !reportType;

    return (
      <div className="warranty-report-container">
        {loadingFile && (
          <Dimmer active inverted>
            <Loader inverted content="Generando Archivo..." />
          </Dimmer>
        )}
        <Card raised fluid>
          <div className="title-bar">
            <div className="title">
              <h2>Reporte General de Garantías</h2>
              <Label className="warranty-total" color="red">
                Total garantías
                <Label.Detail>{countRows}</Label.Detail>
              </Label>
              <div className="title-bar-actions">
                <GenerateFileModal
                  state={this.state}
                  disable={validateForm || !reportList.length}
                  loading={loading}
                />
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          <div className="warranty-report-form">
            <Form>
              <SearchFormMany
                {...this.state}
                campaignOptions={campaignList}
                dealersOptions={dealers}
                warrantyStatus={warrantyStatus}
                handleChange={this.handleChange}
                handleChangeDate={this.handleChangeDate}
              />
              <div className="btn-search">
                <Button secondary disabled={loading} onClick={this.handleClear}>
                  LIMPIAR
                </Button>
                <Button
                  disabled={validateForm || loading}
                  onClick={this.handleSearch}
                  type="submit"
                  color="green"
                >
                  BUSCAR
                </Button>
              </div>
            </Form>
          </div>
        </Card>
        <Card raised fluid className="warranty-report-table">
          {this.renderContent(validateForm)}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'dealers': state.dealer.list,
    'warrantyStatus': state.processedWarranty.warrantyStatus,
    'loading': state.warrantyReport.loading,
    'reportList': state.warrantyReport.list,
    'fileURL': state.warrantyReport.fileURL,
    'loadingFile': state.warrantyReport.loadingFile,
    'campaignList': state.campaignList.list,
  };
};

const {
  navigateTo,
  withRouter,
  fetchDealers,
  fetchCampaignList,
  fetchWarrantyStatus,
  fetchWarrantyReportList,
  clearWarrantyReportList,
  clearSearchPartWarranty,
  clearWarrantyReportURLFile,
  clearReplacementSectionPartQuotes,
} = Actions;

const mapDispatchToProps = {
  navigateTo,
  fetchDealers,
  fetchCampaignList,
  fetchWarrantyStatus,
  fetchWarrantyReportList,
  clearWarrantyReportList,
  clearSearchPartWarranty,
  clearWarrantyReportURLFile,
  clearReplacementSectionPartQuotes,
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WarrantyReport)
);
